import { render, staticRenderFns } from "./LeaveSumStat.vue?vue&type=template&id=b629c298&scoped=true"
import script from "./LeaveSumStat.vue?vue&type=script&lang=js"
export * from "./LeaveSumStat.vue?vue&type=script&lang=js"
import style0 from "./LeaveSumStat.vue?vue&type=style&index=0&id=b629c298&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b629c298",
  null
  
)

export default component.exports